
import Vue from 'vue'

export default Vue.extend({
  name: 'HomepageNews',
  mounted() {
    this.$api('/articles/newses?sortBy=order&sortDirection=asc&page=1&itemsPerPage=4').then(
      (response) => (this.items = response.data['items'])
    )
  },
  data: () => ({
    items: [],
  }),
})
